module.exports = __webpack_public_path__ + "img/app-icon-7.f0df1cc6.svg";